// import Member1 from '../Assets/Images/Our-team/member1.avif';
import Member2 from '../Assets/Images/Our-team/member2.avif';
import Member3 from '../Assets/Images/Our-team/member3.avif';
import Member4 from '../Assets/Images/Our-team/member4.avif';
// import Member5 from '../Assets/Images/Our-team/member5.avif';
import Member6 from '../Assets/Images/Our-team/member6.avif';
import Member7 from '../Assets/Images/Our-team/member7.avif';
import Member8 from '../Assets/Images/Our-team/member8.avif';
import Member9 from '../Assets/Images/Our-team/member9.avif';
import Member10 from '../Assets/Images/Our-team/member10.avif';
import Member11 from '../Assets/Images/Our-team/member11.avif';
import Member12 from '../Assets/Images/Our-team/member12.avif';
import Member13 from '../Assets/Images/Our-team/member13.avif';
import Member14 from '../Assets/Images/Our-team/member14.avif';
import Member15 from '../Assets/Images/Our-team/member15.avif';
// import Member16 from '../Assets/Images/Our-team/member16.avif';
import Member17 from '../Assets/Images/Our-team/member17.avif';
import Member18 from '../Assets/Images/Our-team/member18.avif';
import Member19 from '../Assets/Images/Our-team/member19.avif';
import Member20 from '../Assets/Images/Our-team/member20.avif';
import Member21 from '../Assets/Images/Our-team/member21.avif';
import Member22 from '../Assets/Images/Our-team/member22.avif';
import Member23 from '../Assets/Images/Our-team/member23.avif';
import Member24 from '../Assets/Images/Our-team/member24.avif';
import Member25 from '../Assets/Images/Our-team/member25.avif';
import Member26 from '../Assets/Images/Our-team/member26.avif';
import Member27 from '../Assets/Images/Our-team/member27.avif';
import Member28 from '../Assets/Images/Our-team/member28.avif';
import Member29 from '../Assets/Images/Our-team/member29.avif';
import Member30 from '../Assets/Images/Our-team/member30.avif';

export const teamMembers = [
  {
    title: 'HR Executive',
    name: 'Rima Maru',
    image: Member29
  },
  {
    title: 'Business Development Executive',
    name: 'Ankit Jha',
    image: Member28
  },
  {
    title: 'Sr. Full Stack Developer',
    name: 'Mayur Bhagat',
    image: Member17
  },
  {
    title: 'Sr. Full Stack Developer',
    name: 'Piyush Ajagiya',
    image: Member11
  },
  {
    title: 'Sr. Full Stack Developer',
    name: 'Divyesh Patel',
    image: Member24
  },
  {
    title: 'MERN - Sr. Full Stack Developer',
    name: 'Akshay Sukhadiya',
    image: Member8
  },
  {
    title: 'MERN - Sr. Full Stack Developer',
    name: 'Sanket Kanani',
    image: Member14
  },
  {
    title: 'MERN - Sr. Full Stack Developer',
    name: 'Chirag Gauswami',
    image: Member18
  },
  {
    title: 'MERN - Sr. Full Stack Developer',
    name: 'Urvish Sakhavala',
    image: Member20
  },
  {
    title: 'MERN - Sr. Full Stack Developer',
    name: 'Vivek Sarvaiya',
    image: Member7
  },
  {
    title: 'Sr. Full Stack Developer',
    name: 'Rushi Vaghasiya',
    image: Member9
  },
  {
    title: 'Mobile App Developer',
    name: 'Jaydip Bokha',
    image: Member15
  },
  {
    title: 'Game Developer',
    name: 'Mayur Vora',
    image: Member21
  },
  {
    title: 'MERN Stack Developer',
    name: 'Sarmi Patoliya',
    image: Member10
  },
  {
    title: 'UI/UX Designer',
    name: 'Diksha Shani',
    image: Member19
  },
  {
    title: 'Mobile App Developer',
    name: 'Mahima Vaghela',
    image: Member23
  },
  {
    title: 'Jr. Full Stack Developer',
    name: 'Dhruv Zanzmera',
    image: Member2
  },
  {
    title: 'Frontend Developer',
    name: 'Ghanshyam Ajagiya',
    image: Member6
  },
  // {
  //   title: 'Jr. Full Stack Developer',
  //   image: Member1
  // },
  {
    title: 'Jr. MERN Stack Developer',
    name: 'Shruti Ghevariya',
    image: Member4
  },
  {
    title: 'QA Engineer',
    name: 'Mohit Sirsath',
    image: Member3
  },
  // {
  //   title: 'HR Manager',
  //   image: Member5
  // },
  {
    title: 'Frontend Trainee',
    name: 'Surabhi Sakariya',
    image: Member12
  },
  {
    title: 'QA Engineer',
    name: 'Jagruti Savaliya',
    image: Member13
  },
  // {
  //   title: 'MERN Stack Trainee',
  //   image: Member16
  // },
  {
    title: 'QA Trainee',
    name: 'Ankit Ajagiya',
    image: Member22
  },
  {
    title: 'MERN Stack Trainee',
    name: 'Darshan Viradiya',
    image: Member25
  },
  {
    title: 'UI/UX Designer',
    name: 'Neet Zadafiya',
    image: Member26
  },
  {
    title: 'Jr. MERN Stack Developer',
    name: 'Nirali Baria',
    image: Member27
  },
  {
    title: 'MERN Stack Developer',
    name: 'Deepika Tiwari',
    image: Member30
  }
];
